import axios from "axios";
import { markSessionExpired } from "./sessionExpiredFlag";

let interceptorRegistered = false;
export const setupAxiosInterceptor = () => {
    if (interceptorRegistered) return;
    interceptorRegistered = true;
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const errorCode = error?.response?.data?.code;
            const message = error?.response?.data?.message;
            const isSessionExpired =
                (status === 401 && errorCode === "UNAUTHORIZED_ACCESS") ||
                errorCode === "TOKEN_EXPIRED" ||
                message === "Session expired";

            if (isSessionExpired) {
                markSessionExpired();
            }
            return Promise.reject(error);
        }
    );
}; 